/**
 * Shared API helpers for Winwin auth / account (credentialed CORS to the bridge).
 * Uses cookie when available, plus localStorage bearer token fallback
 * (third-party cookies are often blocked cross-site).
 */
window.WinwinApi = (function () {
  var DEFAULT_BASE = 'https://api.winwingeneve.ch';
  var TOKEN_KEY = 'ww_bidder_token';
  var NAME_KEY = 'ww_bidder_name';

  function normalizeBase(url) {
    var base = (url || DEFAULT_BASE).replace(/\/$/, '');
    if (!base || base.indexOf('onrender.com') !== -1) return DEFAULT_BASE;
    return base;
  }

  function baseFrom(el) {
    if (!el) return DEFAULT_BASE;
    return normalizeBase(el.dataset.apiDirect || DEFAULT_BASE);
  }

  function getToken() {
    try { return window.localStorage.getItem(TOKEN_KEY) || ''; } catch (e) { return ''; }
  }

  function getCachedName() {
    try { return window.localStorage.getItem(NAME_KEY) || ''; } catch (e) { return ''; }
  }

  function setAuthUi(authed, user) {
    try {
      if (authed) {
        document.documentElement.classList.add('ww-authed');
        if (user) {
          var name = user.firstname || user.name || '';
          if (name) window.localStorage.setItem(NAME_KEY, name);
        }
      } else {
        document.documentElement.classList.remove('ww-authed');
        window.localStorage.removeItem(NAME_KEY);
      }
    } catch (e) {}
  }

  function setToken(token) {
    try {
      if (token) {
        window.localStorage.setItem(TOKEN_KEY, token);
        setAuthUi(true);
      } else {
        window.localStorage.removeItem(TOKEN_KEY);
        setAuthUi(false);
      }
    } catch (e) {}
  }

  async function request(apiBase, path, options) {
    options = options || {};
    var headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    var token = getToken();
    if (token) headers.Authorization = 'Bearer ' + token;
    Object.assign(headers, options.headers || {});

    var res = await fetch(normalizeBase(apiBase) + path, {
      method: options.method || 'GET',
      credentials: 'include',
      headers: headers,
      body: options.body ? JSON.stringify(options.body) : undefined
    });
    var data = null;
    try { data = await res.json(); } catch (e) { data = null; }
    if (data && data.token) setToken(data.token);
    if (data && data.user) setAuthUi(true, data.user);
    if (path === '/logout' || (data && data.authenticated === false)) {
      setToken('');
    }
    return { ok: res.ok, status: res.status, data: data };
  }

  /** Download a binary response (e.g. invoice PDF) with auth. */
  async function download(apiBase, path, filename) {
    var headers = { Accept: 'application/pdf, application/octet-stream, */*' };
    var token = getToken();
    if (token) headers.Authorization = 'Bearer ' + token;
    var res = await fetch(normalizeBase(apiBase) + path, {
      method: 'GET',
      credentials: 'include',
      headers: headers
    });
    if (!res.ok) {
      var err = null;
      try { err = await res.json(); } catch (e) { err = null; }
      return { ok: false, status: res.status, error: (err && (err.error || err.message)) || 'Download failed' };
    }
    var blob = await res.blob();
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename || 'document.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
    return { ok: true, status: res.status };
  }

  return {
    baseFrom: baseFrom,
    normalizeBase: normalizeBase,
    request: request,
    download: download,
    getToken: getToken,
    setToken: setToken,
    getCachedName: getCachedName,
    setAuthUi: setAuthUi,
    DEFAULT_BASE: DEFAULT_BASE
  };
})();
